module.exports = __webpack_public_path__ + "static/media/Screenshot_4.ddd0eb03.png";